// extracted by mini-css-extract-plugin
export default {"brandPromo":"wF-z","carousel":"xF-z"};